import { aboutInfo } from '@/mocks/about';

export default function AboutMission() {
  return (
    <section className="w-full py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Mission Statement */}
          <div className="flex-1">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
              我们的使命
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              {aboutInfo.mission}
            </p>
            <p className="text-foreground-500 text-sm mt-4 leading-relaxed">
              在这个信息爆炸的时代，我们深知真实、及时的资讯对于每一位吃瓜群众的重要性。911爆料网始终坚持独立、客观的报道原则，不站队、不偏袒，只为还原事件最真实的模样。我们相信，每一个爆料背后都有一个值得被讲述的故事，每一个真相都值得被更多人看见。
            </p>
          </div>

          {/* Right: Stats Grid */}
          <div className="flex-1 w-full">
            <div className="grid grid-cols-2 gap-4">
              {aboutInfo.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-lg p-5 md:p-6 text-center"
                >
                  <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500">
                    {stat.value}
                  </p>
                  <p className="text-foreground-500 text-xs md:text-sm mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}